import { Controller, UseControllerProps } from 'react-hook-form';
import { useTranslation } from 'src/components/dashboard/form/i18n';
import { useAuth } from 'src/contexts/JWTContext';
import { TextField, TextFieldProps } from 'material-hu';
import { getAnswerAutocompleteField } from 'src/utils/form';

export type FormTextFieldProps = TextFieldProps &
  UseControllerProps & {
    answer?: string;
    userField?: string;
    autoCompleteBoss?: string;
  };

export const FormAutocompleteField = ({
  name,
  fullWidth = true,
  userField,
  autoCompleteBoss,
  answer,
  label,
}: FormTextFieldProps) => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const isCompleted = location.pathname.includes('completed') || !!answer;

  const showAnswer = isCompleted
    ? answer
    : getAnswerAutocompleteField(userField, autoCompleteBoss, user, t);

  return (
    <Controller
      render={() => (
        <TextField
          disabled
          label={label}
          fullWidth={fullWidth}
          InputProps={{ sx: { background: '#EFF1F4' } }}
          value={showAnswer}
        />
      )}
      name={name}
      defaultValue={showAnswer}
    />
  );
};

export default FormAutocompleteField;
